<template>
  <el-menu
    :default-active="activeIndex"
    class="el-menu-header"
    mode="horizontal"
    @select="handleSelect"
  >
    <el-menu-item :index="i.path" v-for="i of menuList" :key="i.path">{{
      i.label
    }}</el-menu-item>
  </el-menu>
</template>

<script>
export default {
  name: "HeaderMenu",
  data() {
    return {};
  },
  computed: {
    activeIndex() {
      return this.$route?.meta?.activePath || this.$route.path;
    },
    activeInfo() {
      return this.$store.state.user.activeInfo;
    },
    menuList() {
      const arr = [
        {
          label: "首页",
          path: "/home",
        },
        {
          label: "比赛指南",
          path: "/competitionGuide",
        },
        // {
        //   label: "获奖名单",
        //   path: "/listOfWinners",
        // },
        {
          label: "我要报名",
          path: "/needRegister",
        },
        {
          label: "进入专家评审",
          path: "/expertReview",
        },
      ];
      // 上线增加判断
      // if (this.activeInfo.activeState > 2) {
      //   arr.splice(2, 0, {
      //     label: "作品展示",
      //     path: "/workDisplay",
      //   });
      // }
      if (this.$store.state.user.dsUser && this.$store.state.user.dsUser.userType === 1) {
        const index = arr.findIndex((item) => item.path === "/expertReview");
        arr.splice(index, 1);
      } else if(this.$store.state.user.dsUser && this.$store.state.user.dsUser.userType === 2) {
        const index = arr.findIndex((item) => item.path === "/needRegister");
        arr.splice(index, 1);
      }
      return arr;
    },
  },
  methods: {
    handleSelect(key) {
      if (this.activeIndex != key) {
        this.$router.push({ path: key });
      }
    },
  },
};
</script>

<style lang="less" scoped >
.el-menu-header {
  border-bottom: 0 !important;
  /deep/ .el-menu-item {
    color: #000000;
    border-bottom: 0;
    border-top: 2px solid transparent;
    &.is-active {
      background-color: #f6f7fc;
      color: #436eff !important;
      font-weight: bold;
      border-top: 2px solid #436eff;
      border-bottom: 0;
    }
    &:not(.is-disabled):hover,
    &:not(.is-disabled):focus {
      background-color: #f6f7fc;
    }
  }
}
</style>